import './App.scss';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Footer from './components/landing/footer/Footer.js';
import { useEffect, useState } from 'react';
import Navbar from './components/landing/header/Navbar.js';
import RootPoolDetail from './components/RootPoolDetail/RootPoolDetail.js';
import Stakingpool from './components/Stakingpool/Stakingpool.js';
import Profile from './components/Profile/Profile.js';
import Pools from './components/Pools/Pools.js';
import Createpool from './components/Createpool/Createpool.js';
import Childpool from './components/Childpool/Childpool.js';
import { ToastContainer } from 'react-toastify';

import "react-datepicker/dist/react-datepicker.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isFirstVisit = !localStorage.getItem("hasVisited");

    const timeout = setTimeout(() => {
      setLoading(false);
      localStorage.setItem("hasVisited", "true");
    }, isFirstVisit ? 6000 : 2000);

    return () => clearTimeout(timeout);
  }, []);
  return (
    <>
      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        style={{ zIndex: 999999999999 }}
      />
      <Router>
        <Navbar />
        <Switch>
          <Route exact path='/' component={Landing} />
          <Route exact path='/activepools/:id' component={RootPoolDetail} />
          <Route exact path='/stakingpool' component={Stakingpool} />
          <Route exact path='/profile' component={Profile} />
          <Route exact path='/pools' component={Pools} />
          <Route exact path='/createpool' component={Createpool} />
          <Route exact path='/childpool' component={Childpool} />
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;




